import React, { Component, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getUserNode } from "../../../../services/auth_node";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

//Styles
// import '../../../../assets/css/guia_pages.css';
import EadDuvidasSection from "./EadDuvidasSection";
import { isAuthAdmin } from "../../../../services/auth";

class EadDuvidas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowed: false,
    };
  }

  async componentWillMount() {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
    this.setState({ allowed: true });
  }

  render() {
    return (
      this.state.allowed && (
          <EadDuvidasSection />
      )
    );
  }
}

const mapStateToProps = (store) => ({ view_by_tab: store.home.aba });
export default connect(mapStateToProps)(withRouter(EadDuvidas));
